import { AssetsData } from '@/types/asset';

export const formatPrice = (price: number) => {
  const currencySymbol = getCurrencySymbol();
  const formattedAmount = price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${currencySymbol} ${formattedAmount}`;
};

const getCurrencySymbol = () => {
  return '₹';
};

export type BenefitType = {
  id: number;
  desc: string;
  icon: string;
};

export enum PLAN_INFO_TITLE_TEXT {
  IN_CONTRACT = 'Your device is already under an active AMC',
  IN_WARRANTY = 'Your device is already under an active Warranty',
  UPCOMING_AMC = 'You have already renewed your AMC',
  NO_AMC_PLANS = 'No plans available for your device.',
}

export const getCurrentPlanType = (selectedProduct: AssetsData): 'C' | 'W' => {
  if (
    selectedProduct.expiryStatus &&
    selectedProduct.expiryStatus.status &&
    selectedProduct.expiryStatus.status === 'IC'
  ) {
    return 'C';
  }
  return 'W';
};

export const shouldShowActivePlanInfo = (selectedProduct: AssetsData): boolean => {
  if (!selectedProduct) {
    return false;
  }

  const { status, isAboutToExpire = false } = selectedProduct?.expiryStatus;

  if (
    !status ||
    status === 'OC' ||
    status === 'OW' ||
    ((status === 'IC' || status === 'IW') && isAboutToExpire)
  ) {
    return false;
  }
  return true;
};
